import * as pdfjsLib from "pdfjs-dist";

pdfjsLib.GlobalWorkerOptions.workerSrc = "https://unpkg.com/pdfjs-dist@5.4.149/build/pdf.worker.mjs";

class PDFViewer extends HTMLElement {
  constructor () {
    super();

    this.attachShadow({ mode: "open" });
  }

  async connectedCallback() {
    const src = this.getAttribute("src");
    const url = new URL(src, location);
    const pdf = await pdfjsLib.getDocument({ url }).promise;
    const page = await pdf.getPage(1);
    const viewport = page.getViewport({scale: 1.0});
    const canvas = document.createElement("canvas");
    this.shadowRoot.appendChild(canvas);

    const context = canvas.getContext("2d");

    canvas.width = viewport.width;
    canvas.height = viewport.height;
    canvas.style.width = "100%";
    canvas.style.height = "auto";
    await page.render({
      canvasContext: context,
      viewport
    }).promise;
  }
}

customElements.define("pdf-viewer", PDFViewer);
